/* Request Context Actions */
export enum RequestActionTypes {
  UpdateRequestStatus = 'UpdateRequestStatus',
  UpdateResponseState = 'UpdateResponseState',
  UpdateSuccessMessage = 'UpdateSuccessMessage',
  UpdateErrorMessage = 'UpdateErrorMessage',
  ClearErrorMessage = 'ClearErrorMessage',
}
